import React, { useState } from "react";
import Titles from "../layouts/Titles";
import Achievements from "./Achievements";
import Education from "./Education";
import Exprience from "./Exprience";
import MySkills from "./MySkills";
const MyResume = () => {
  const [educationData, setEducationData] = useState(true);
  const [skillsData, setSkillsData] = useState(false);
  const [experienceData, setExperienceData] = useState(false);
  const [achievementsData, setAchievementData] = useState(false);
  return (
    <section
      id="resume"
      className="w-full h-full py-20  border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Titles title="4+ EXPRIENCE" des="My Resume" />
      </div>
      <div>
        <ul className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          <li
            onClick={() =>
              setEducationData(true) &
              setSkillsData(false) &
              setAchievementData(false) &
              setExperienceData(false)
            }
            className= "resumeLi"
          >
            Education
          </li>
          <li
            onClick={() =>
              setEducationData(false) &
              setSkillsData(true) &
              setAchievementData(false) &
              setExperienceData(false)
            }
            className="resumeLi"
          >
            Professional Skills
          </li>
          <li
            onClick={() =>
              setEducationData(false) &
              setSkillsData(false) &
              setExperienceData(true) &
              setAchievementData(false) 
            }
            className="resumeLi"
          >
            Experience
          </li>
          <li
            onClick={() =>
              setEducationData(false) &
              setSkillsData(false) &
              setAchievementData(true) &
              setExperienceData(false)
            }
            className="resumeLi"
          >
            Achievements
          </li>
        </ul>
      </div>
      {educationData && <Education />}
      {skillsData && <MySkills />}
      {experienceData && <Exprience/>}
      {achievementsData && <Achievements/>}
      
    </section>
  );
};

export default MyResume;
